/*
  Glass Hub product customiser.
  Reads the product's variants and mirror details (data-gh-config), keeps the live mirror drawing in step
  with every choice, prices custom sizes through the band variants, runs the design editor, opens the
  3D view, and adds the mirror to the cart with the size, design, uploaded file and a preview picture.
*/
(function () {
  'use strict';

  var GH = window.GH || {};

  function $(root, sel) {
    return root.querySelector(sel);
  }
  function $$(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }
  function fill(text, vars) {
    return String(text || '').replace(/\{(\w+)\}/g, function (m, k) {
      return vars[k] != null ? vars[k] : m;
    });
  }
  function round1(n) {
    return Math.round(n * 10) / 10;
  }

  function formatMoney(cents, format) {
    var amount = (Number(cents) || 0) / 100;
    var group = function (n, dec, sep, point) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return parts.join(point);
    };
    var fmt = format || '{{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_no_decimals') return group(amount, 0, ',', '.');
      if (key === 'amount_with_comma_separator') return group(amount, 2, '.', ',');
      if (key === 'amount_no_decimals_with_comma_separator') return group(amount, 0, '.', ',');
      return group(amount, 2, ',', '.');
    });
  }

  function parseFrameColors(text) {
    var map = {};
    String(text || '')
      .split(/\n/)
      .forEach(function (line) {
        var p = line.split('|');
        if (p.length > 1) map[p[0].trim().toLowerCase()] = p[1].trim();
      });
    return map;
  }

  function Customiser(root) {
    this.root = root;
    this.cfg = JSON.parse($(root, '[data-gh-config]').textContent);
    this.form = $(root, '[data-gh-form]');
    if (!this.form) return;
    this.L = this.cfg.labels || {};
    this.roles = {};
    this.steps = $$(root, '[data-gh-step]');
    var self = this;
    this.steps.forEach(function (step) {
      if (step.dataset.ghOption != null) self.roles[step.dataset.ghStep] = Number(step.dataset.ghOption);
    });
    this.optionCount = this.cfg.variants.length ? this.cfg.variants[0].options.length : 0;
    this.frameColors = parseFrameColors(this.cfg.frameColors);
    this.custom = false;
    this.design = null;
    this.lit = true;

    var sizeStep = this.stepFor('size');
    this.bands = [];
    if (sizeStep) {
      $$(sizeStep, '[data-gh-band]').forEach(function (input) {
        var s = window.GHMirror.sizeFrom(input.value, self.cfg.bandMarker);
        if (s && s.band) self.bands.push({ input: input, value: input.value, band: s.band });
      });
      this.bands.sort(function (a, b) {
        return a.band - b.band;
      });
    }
    this.fitTo = this.largestSize();

    this.mirror = new window.GHMirror($(root, '[data-gh-canvas]'), {
      led: this.cfg.led,
      lit: true,
      border: Number(this.cfg.border) || 0,
      printArea: this.cfg.printArea,
      frostTop: Number(this.cfg.frostTop) || 0,
      frostBottom: Number(this.cfg.frostBottom) || 0,
      r: Number(this.cfg.radius),
      fitTo: this.fitTo,
      unit: GH.units ? { inch: GH.units.inch, cm: GH.units.cm, dia: GH.units.dia } : undefined,
      colors: GH.colors || {},
    });
    if (GH.tones) {
      window.GHMirror.tones.warm = GH.tones.warm;
      window.GHMirror.tones.neutral = GH.tones.neutral;
      window.GHMirror.tones.cool = GH.tones.cool;
    }

    this.bind();
    this.prefillCustom();
    this.update(true);
  }

  Customiser.prototype.stepFor = function (role) {
    for (var i = 0; i < this.steps.length; i++) if (this.steps[i].dataset.ghStep === role) return this.steps[i];
    return null;
  };

  Customiser.prototype.optionInputs = function (index) {
    var step = this.root.querySelector('[data-gh-option="' + index + '"]');
    return step ? $$(step, 'input[name^="options["]') : [];
  };

  Customiser.prototype.largestSize = function () {
    var sizeStep = this.stepFor('size');
    var best = null;
    var self = this;
    if (sizeStep) {
      $$(sizeStep, 'input[name^="options["]:not([data-gh-band])').forEach(function (input) {
        var s = window.GHMirror.sizeFrom(input.value, self.cfg.bandMarker);
        if (s && s.w) {
          if (!best) best = { w: s.w, h: s.h };
          best.w = Math.max(best.w, s.w);
          best.h = Math.max(best.h, s.h);
        }
      });
    }
    return best;
  };

  // The value chosen for option i ("" when nothing is chosen).
  Customiser.prototype.selected = function (index) {
    if (index === this.roles.size && this.custom) {
      var band = this.bandFor(this.customArea(), index);
      return band ? band.value : '';
    }
    var inputs = this.optionInputs(index);
    for (var i = 0; i < inputs.length; i++) if (inputs[i].checked && !inputs[i].hasAttribute('data-gh-band')) return inputs[i].value;
    return '';
  };

  Customiser.prototype.selectedAll = function () {
    var out = [];
    for (var i = 0; i < this.optionCount; i++) out.push(this.selected(i));
    return out;
  };

  Customiser.prototype.variantFor = function (opts) {
    var list = this.cfg.variants;
    for (var i = 0; i < list.length; i++) {
      var v = list[i];
      var ok = true;
      for (var j = 0; j < opts.length; j++) if (v.options[j] !== opts[j]) ok = false;
      if (ok) return v;
    }
    return null;
  };

  // 'ok', 'soldout' or 'none' for value v of option i, given the choices for the options before it.
  Customiser.prototype.valueState = function (i, v, opts) {
    var list = this.cfg.variants;
    var exists = false;
    for (var n = 0; n < list.length; n++) {
      var o = list[n].options;
      if (o[i] !== v) continue;
      var match = true;
      for (var j = 0; j < i; j++) if (opts[j] && o[j] !== opts[j]) match = false;
      if (!match) continue;
      exists = true;
      if (list[n].available) return 'ok';
    }
    return exists ? 'soldout' : 'none';
  };

  // After option i changed: if the combination does not exist, move the options after it to the
  // first combination that does (and is in stock), keeping as many choices as possible.
  Customiser.prototype.repair = function (changed) {
    var opts = this.selectedAll();
    var v = this.variantFor(opts);
    if (v && v.available) return;
    var list = this.cfg.variants;
    var best = null;
    var bestScore = -1;
    for (var n = 0; n < list.length; n++) {
      var o = list[n].options;
      if (!list[n].available) continue;
      var ok = true;
      for (var j = 0; j <= changed; j++) if (opts[j] && o[j] !== opts[j]) ok = false;
      if (!ok) continue;
      var score = 0;
      for (var m = changed + 1; m < o.length; m++) if (o[m] === opts[m]) score++;
      // prefer a standard size over a custom band
      if (this.roles.size != null && this.bands.some(function (b) { return b.value === o[this.roles.size]; }, this)) score -= 0.5;
      if (score > bestScore) {
        bestScore = score;
        best = o;
      }
    }
    if (!best) return;
    for (var k = 0; k < best.length; k++) {
      if (k === changed) continue;
      if (k === this.roles.size && this.custom) continue;
      this.optionInputs(k).forEach(function (input) {
        if (!input.hasAttribute('data-gh-band')) input.checked = input.value === best[k];
      });
    }
  };

  Customiser.prototype.kind = function () {
    if (this.roles.shape != null) return window.GHMirror.kindFrom(this.selected(this.roles.shape), this.cfg.kind);
    return this.cfg.kind || 'rectangle';
  };

  Customiser.prototype.isRoundish = function () {
    var k = this.kind();
    return k === 'round' || k === 'square';
  };

  Customiser.prototype.customDims = function () {
    var w = parseFloat($(this.root, '[data-gh-w]').value) || 0;
    var h = this.isRoundish() ? w : parseFloat($(this.root, '[data-gh-h]').value) || 0;
    return { w: w, h: h };
  };

  Customiser.prototype.customArea = function () {
    var d = this.customDims();
    return (d.w * d.h) / 144;
  };

  // The smallest band that covers the area and exists, in stock, with the other choices.
  Customiser.prototype.bandFor = function (area, sizeIndex) {
    if (!area) return null;
    for (var i = 0; i < this.bands.length; i++) {
      var b = this.bands[i];
      if (b.band + 1e-9 < area) continue;
      var opts = [];
      for (var j = 0; j < this.optionCount; j++) opts.push(j === sizeIndex ? b.value : j === this.roles.size ? '' : this.selected(j));
      var v = this.variantFor(opts);
      if (v && v.available) return b;
    }
    return null;
  };

  Customiser.prototype.customCheck = function () {
    var d = this.customDims();
    var lim = this.cfg.limits || {};
    if (!d.w || !d.h) return { ok: false, msg: '' };
    if ((lim.minW && d.w < lim.minW) || (lim.minH && d.h < lim.minH)) return { ok: false, msg: this.L.tooSmall };
    if ((lim.maxW && d.w > lim.maxW) || (lim.maxH && d.h > lim.maxH)) return { ok: false, msg: this.L.tooBig };
    if (!this.bandFor(this.customArea(), this.roles.size)) return { ok: false, msg: this.L.noBand };
    return { ok: true, msg: '' };
  };

  Customiser.prototype.dims = function () {
    if (this.custom) {
      var d = this.customDims();
      if (d.w && d.h) return d;
    }
    if (this.roles.size != null) {
      var s = window.GHMirror.sizeFrom(this.selected(this.roles.size), this.cfg.bandMarker);
      if (s && s.w) return { w: s.w, h: s.h };
    }
    return this.fitTo || { w: 24, h: 36 };
  };

  Customiser.prototype.tone = function () {
    if (this.roles.light == null) return 'warm';
    var inputs = this.optionInputs(this.roles.light);
    for (var i = 0; i < inputs.length; i++) if (inputs[i].checked) return inputs[i].dataset.ghTone || 'warm';
    return 'warm';
  };

  Customiser.prototype.frame = function () {
    var width = Number(this.cfg.frameWidth) || 0;
    var color = this.cfg.frameColor;
    if (this.roles.frame != null) {
      var v = this.selected(this.roles.frame).toLowerCase();
      if (/no frame|without|none/.test(v)) return null;
      for (var name in this.frameColors) if (v.indexOf(name) !== -1) color = this.frameColors[name];
      if (!width) width = 0.8;
    }
    if (!width) return null;
    return { width: width, depth: Number(this.cfg.frameDepth) || 0.8, color: color || '#C3C8CC', wood: !!this.cfg.frameWood };
  };

  /* ----------------------------------------------------------- events */

  Customiser.prototype.bind = function () {
    var self = this;
    var root = this.root;

    this.form.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-gh-custom-toggle]')) {
        self.custom = true;
        self.optionInputs(self.roles.size).forEach(function (i) {
          if (!i.hasAttribute('data-gh-band')) i.checked = false;
        });
      } else if (self.roles.size != null && t.name && t.name.indexOf('options[') === 0 && t.closest('[data-gh-step="size"]')) {
        self.custom = false;
        var toggle = $(root, '[data-gh-custom-toggle]');
        if (toggle) toggle.checked = false;
      }
      if (t.matches('[data-gh-upload]')) return self.useUpload(t);
      if (t.name === 'gh-design') return self.useDesign(t);
      var step = t.closest('[data-gh-option]');
      if (step) self.repair(Number(step.dataset.ghOption));
      self.update();
      self.ensureLive();
    });
    $$(root, '[data-gh-w], [data-gh-h]').forEach(function (input) {
      input.addEventListener('input', function () {
        self.ensureLive();
        self.update();
      });
    });

    var light = $(root, '[data-gh-light]');
    if (light) {
      light.addEventListener('click', function () {
        self.lit = !self.lit;
        light.setAttribute('aria-pressed', self.lit ? 'true' : 'false');
        light.classList.toggle('is-on', self.lit);
        $(light, '[data-gh-light-label]').textContent = self.lit ? self.L.lightOn : self.L.lightOff;
        self.ensureLive();
        self.mirror.set({ lit: self.lit });
        if (self.three) self.three.update({ lit: self.lit });
      });
    }

    $$(root, '[data-gh-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = self.form.querySelector('[name="quantity"]');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(btn.dataset.ghQty));
      });
    });

    $$(root, '[data-gh-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        self.showSlide(thumb.dataset.ghThumb);
      });
    });

    var open3d = $(root, '[data-gh-open3d]');
    if (open3d) open3d.addEventListener('click', function () { self.open3d(); });
    var close3d = $(root, '[data-gh-close3d]');
    if (close3d) close3d.addEventListener('click', function () { self.close3d(); });
    var reset3d = $(root, '[data-gh-reset3d]');
    if (reset3d) reset3d.addEventListener('click', function () { if (self.three) self.three.reset(); });

    this.bindEditor();

    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.submit();
    });
  };

  Customiser.prototype.prefillCustom = function () {
    var w = $(this.root, '[data-gh-w]');
    if (!w) return;
    // the first variant may be a custom size band: start in custom mode then
    var bandChecked = this.bands.some(function (b) {
      return b.input.checked;
    });
    if (bandChecked) {
      this.custom = true;
      var toggle = $(this.root, '[data-gh-custom-toggle]');
      if (toggle) toggle.checked = true;
    }
    var d = this.dims();
    var lim = this.cfg.limits || {};
    w.value = d.w || lim.minW || 24;
    $(this.root, '[data-gh-h]').value = d.h || lim.minH || 36;
    if (lim.minW) w.min = lim.minW;
    if (lim.maxW) w.max = lim.maxW;
  };

  /* ----------------------------------------------------------- update */

  Customiser.prototype.update = function (first) {
    var self = this;
    var root = this.root;
    var opts = this.selectedAll();
    var variant = this.variantFor(opts);
    var d = this.dims();
    var kind = this.kind();

    // Each option is checked against the choices above it only: a size the chosen shape is not made
    // in is hidden, one that is made but sold out is struck through. A shape is never struck out
    // just because the current size does not exist for it (picking it moves the size along).
    for (var i = 0; i < this.optionCount; i++) {
      this.optionInputs(i).forEach(function (input) {
        if (input.hasAttribute('data-gh-band')) return;
        var tile = input.closest('.gh-tile');
        if (!tile) return;
        var state = self.valueState(i, input.value, opts);
        tile.hidden = state === 'none';
        tile.classList.toggle('is-off', state === 'soldout');
      });
    }
    var customTile = $(root, '[data-gh-custom-toggle]');
    if (customTile && this.roles.size != null) {
      var anyBand = this.bands.some(function (b) {
        return self.valueState(self.roles.size, b.value, opts) === 'ok';
      });
      customTile.closest('.gh-tile').hidden = !anyBand;
    }

    // custom size box
    var customBox = $(root, '[data-gh-custom]');
    var check = { ok: true, msg: '' };
    if (customBox) {
      customBox.hidden = !this.custom;
      var roundish = this.isRoundish();
      $(root, '[data-gh-h-field]').hidden = roundish;
      $(root, '[data-gh-h-wrap]').hidden = roundish;
      $(root, '[data-gh-w-label]').textContent = kind === 'round' ? this.L.diameter : this.L.width;
      if (this.custom) {
        check = this.customCheck();
        var lim = this.cfg.limits || {};
        var msg = check.msg;
        if (!msg && (lim.minW || lim.maxW)) msg = fill(this.L.range, { min_w: lim.minW, max_w: lim.maxW, min_h: lim.minH, max_h: lim.maxH });
        $(root, '[data-gh-custom-msg]').textContent = msg || '';
        $(root, '[data-gh-custom-msg]').classList.toggle('is-error', !check.ok && !!check.msg);
        var band = check.ok ? this.bandFor(this.customArea(), this.roles.size) : null;
        this.bands.forEach(function (b) {
          b.input.checked = band === b;
        });
      }
    }

    // cm under each fixed size
    $$(root, '[data-gh-cm]').forEach(function (el) {
      if (el.textContent) return;
      var input = el.closest('label').querySelector('input');
      var s = window.GHMirror.sizeFrom(input.value, self.cfg.bandMarker);
      if (s && s.w) el.textContent = s.w === s.h ? Math.round(s.w * 2.54) + ' ' + GH.units.cm : Math.round(s.w * 2.54) + ' × ' + Math.round(s.h * 2.54) + ' ' + GH.units.cm;
    });

    // price, SKU, button
    var priceEl = $(root, '[data-gh-price]');
    var addBtn = $(root, '[data-gh-add]');
    var addLabel = $(root, '[data-gh-add-label]');
    var idInput = $(root, '[data-gh-variant]');
    var missing = this.missingSteps();
    var usable = variant && variant.available && check.ok;
    if (variant) {
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price, this.cfg.moneyFormat);
      var cmp = $(root, '[data-gh-compare]');
      if (cmp) {
        cmp.hidden = !(variant.compare > variant.price);
        cmp.textContent = formatMoney(variant.compare, this.cfg.moneyFormat);
      }
      var sku = $(root, '[data-gh-sku]');
      if (sku) {
        sku.textContent = (variant.sku || '').replace(/^SKU[- ]/i, '');
        $(root, '[data-gh-sku-row]').hidden = !variant.sku;
      }
      var addPrice = $(root, '[data-gh-add-price]');
      if (addPrice) addPrice.textContent = formatMoney(variant.price, this.cfg.moneyFormat);
    }
    if (addBtn && !this.cfg.comingSoon) {
      addBtn.disabled = !usable;
      addLabel.textContent = !variant ? this.L.unavailable : !variant.available ? this.L.soldOut : missing.length ? this.L.nextStep || this.L.add : this.L.add;
      addBtn.classList.toggle('is-next', usable && missing.length > 0);
    }

    // how the custom price was worked out
    var working = $(root, '[data-gh-working]');
    if (working) {
      if (this.custom && check.ok) {
        var b2 = this.bandFor(this.customArea(), this.roles.size);
        working.textContent = fill(this.L.working, { w: round1(d.w), h: round1(d.h), area: round1(this.customArea()), band: b2 ? b2.value : '' }) + (this.L.bandNote ? ' ' + this.L.bandNote : '');
        working.hidden = false;
      } else working.hidden = true;
    }

    // things saved with the order
    var props = {
      w: $(root, '[data-gh-prop-w]'),
      h: $(root, '[data-gh-prop-h]'),
      area: $(root, '[data-gh-prop-area]'),
      design: $(root, '[data-gh-prop-design]'),
      editor: $(root, '[data-gh-prop-editor]'),
    };
    var customOn = this.custom && check.ok;
    props.w.disabled = props.h.disabled = props.area.disabled = !customOn;
    if (customOn) {
      props.w.value = round1(d.w);
      props.h.value = round1(d.h);
      props.area.value = round1(this.customArea());
    }
    props.design.disabled = !this.design;
    props.editor.disabled = !this.design;
    if (this.design) {
      props.design.value = this.design.name + (this.design.code && this.design.code !== this.design.name ? ' (' + this.design.code + ')' : '');
      props.editor.value = JSON.stringify({ kind: kind, w: round1(d.w), h: round1(d.h), x: round1(this.design.x), y: round1(this.design.y), zoom: Math.round(this.design.scale * 100), rotate: Math.round(this.design.rot) });
    }

    this.summary(d);
    this.stepValues(d);

    var thumbShape = $(root, '[data-gh-thumb-shape]');
    if (thumbShape) thumbShape.dataset.kind = kind;

    this.mirror.set({ kind: kind, w: d.w, h: d.h, tone: this.tone(), frame: this.frame(), design: this.design, editing: !!this.design });
    this.lowRes();
    if (this.three) this.push3d();
  };

  Customiser.prototype.missingSteps = function () {
    var out = [];
    for (var i = 0; i < this.optionCount; i++) if (!this.selected(i)) out.push(i);
    if (this.stepFor('design') && !this.design) out.push('design');
    return out;
  };

  Customiser.prototype.stepValue = function (step, d) {
    var role = step.dataset.ghStep;
    if (role === 'design') return this.design ? this.design.name : '';
    var index = Number(step.dataset.ghOption);
    if (role === 'size' && this.custom) {
      return this.customCheck().ok ? (this.isRoundish() ? round1(d.w) + ' ' + GH.units.inch : round1(d.w) + ' × ' + round1(d.h) + ' ' + GH.units.inch) : '';
    }
    return this.selected(index);
  };

  Customiser.prototype.stepValues = function (d) {
    var self = this;
    this.steps.forEach(function (step) {
      var el = $(step, '[data-gh-step-value]');
      var v = self.stepValue(step, d);
      if (el) el.textContent = v;
      step.classList.toggle('is-done', !!v);
    });
  };

  Customiser.prototype.summary = function (d) {
    var list = $(this.root, '[data-gh-summary]');
    if (!list) return;
    var self = this;
    list.innerHTML = '';
    this.steps.forEach(function (step) {
      var v = self.stepValue(step, d);
      var li = document.createElement('li');
      li.className = v ? 'is-done' : 'is-todo';
      var name = document.createElement('span');
      name.textContent = $(step, '.gh-step__title').textContent;
      var val = document.createElement('strong');
      val.textContent = v || self.L.todo;
      li.appendChild(name);
      li.appendChild(val);
      list.appendChild(li);
    });
  };

  /* ----------------------------------------------------------- slides */

  Customiser.prototype.showSlide = function (which) {
    var root = this.root;
    if (which !== 'three' && this.three) this.close3d(true);
    $$(root, '[data-gh-slide]').forEach(function (slide) {
      var on = slide.dataset.ghSlide === which;
      slide.hidden = !on;
      slide.classList.toggle('is-active', on);
    });
    var three = $(root, '[data-gh-three]');
    if (three) three.hidden = which !== 'three';
    $$(root, '[data-gh-thumb]').forEach(function (t) {
      var on = t.dataset.ghThumb === which || (which === 'three' && t.dataset.ghThumb === 'live');
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    if (which === 'live') this.mirror.resize(), this.mirror.draw();
  };

  // The page may open on a photo; the first choice brings the live drawing forward.
  Customiser.prototype.ensureLive = function () {
    var live = this.root.querySelector('[data-gh-slide="live"]');
    if (live && live.hidden && !this.three) this.showSlide('live');
  };

  /* --------------------------------------------------------------- 3D */

  Customiser.prototype.threeOpts = function () {
    var d = this.dims();
    var kind = this.kind();
    var r = Number(this.cfg.radius);
    return {
      points: window.GHMirror.outline(kind, d.w, d.h, r),
      w: d.w,
      h: d.h,
      overlay: this.mirror.printTexture(1024),
      led: !!this.cfg.led,
      lit: this.lit,
      tone: window.GHMirror.tones[this.tone()] || window.GHMirror.tones.warm,
      frame: this.frame(),
      wall: GH.colors && GH.colors.wall,
      reduced: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    };
  };

  Customiser.prototype.push3d = function () {
    var o = this.threeOpts();
    var key = [this.kind(), o.w, o.h, JSON.stringify(o.frame), o.tone].join('|');
    if (key !== this.threeKey) {
      this.threeKey = key;
      this.three.update(o);
    } else this.three.update({ overlay: o.overlay, lit: o.lit });
  };

  Customiser.prototype.open3d = function () {
    var self = this;
    var root = this.root;
    var mount = $(root, '[data-gh-mount]');
    var loading = $(root, '[data-gh-3dloading]');
    this.showSlide('three');
    if (this.three) return;
    var test = document.createElement('canvas');
    var gl = test.getContext('webgl2') || test.getContext('webgl');
    if (!gl) {
      this.showSlide('live');
      return;
    }
    loading.hidden = false;
    import(GH.mirror3d)
      .then(function (mod) {
        loading.hidden = true;
        var o = self.threeOpts();
        self.threeKey = [self.kind(), o.w, o.h, JSON.stringify(o.frame), o.tone].join('|');
        self.three = mod.mount(mount, o);
      })
      .catch(function (err) {
        loading.hidden = true;
        console.error(err);
        self.showSlide('live');
      });
  };

  Customiser.prototype.close3d = function (silent) {
    if (this.three) {
      this.three.destroy();
      this.three = null;
    }
    if (!silent) this.showSlide('live');
  };

  /* ----------------------------------------------------------- design */

  Customiser.prototype.loadImage = function (src, cb) {
    var img = new Image();
    if (!/^blob:|^data:/.test(src)) img.crossOrigin = 'anonymous';
    img.decoding = 'async';
    img.onload = function () {
      cb(img);
    };
    img.onerror = function () {
      cb(null);
    };
    img.src = src;
  };

  Customiser.prototype.useDesign = function (input) {
    var self = this;
    var upload = $(this.root, '[data-gh-upload]');
    if (upload) {
      upload.value = '';
      upload.closest('.gh-design').classList.remove('is-chosen');
    }
    this.loadImage(input.dataset.ghDesignSrc, function (img) {
      if (!img) return;
      self.setDesign({ name: input.dataset.ghDesignName, code: input.value, img: img, file: null });
    });
  };

  Customiser.prototype.useUpload = function (input) {
    var self = this;
    var file = input.files && input.files[0];
    if (!file) return;
    if (!/^image\/(jpeg|png|webp)$/.test(file.type) || file.size > 20 * 1024 * 1024) {
      input.value = '';
      return;
    }
    $$(this.root, 'input[name="gh-design"]').forEach(function (r) {
      r.checked = false;
    });
    var url = URL.createObjectURL(file);
    this.loadImage(url, function (img) {
      if (!img) return;
      input.closest('.gh-design').classList.add('is-chosen');
      self.setDesign({ name: self.L.yourUpload, code: file.name, img: img, file: file });
    });
  };

  Customiser.prototype.setDesign = function (d) {
    d.x = 0;
    d.y = 0;
    d.scale = 1;
    d.rot = 0;
    this.design = d;
    var editor = $(this.root, '[data-gh-editor]');
    if (editor) editor.hidden = false;
    this.syncSliders();
    this.showSlide('live');
    this.update();
  };

  Customiser.prototype.syncSliders = function () {
    var z = $(this.root, '[data-gh-zoom]');
    var r = $(this.root, '[data-gh-rotate]');
    if (!this.design || !z) return;
    z.value = Math.round(this.design.scale * 100);
    var rot = ((this.design.rot + 180) % 360 + 360) % 360 - 180;
    r.value = Math.round(rot);
  };

  Customiser.prototype.editorChanged = function () {
    this.syncSliders();
    this.mirror.set({ design: this.design });
    this.lowRes();
    var editor = $(this.root, '[data-gh-prop-editor]');
    if (editor && this.design) {
      var d = this.dims();
      editor.value = JSON.stringify({ kind: this.kind(), w: round1(d.w), h: round1(d.h), x: round1(this.design.x), y: round1(this.design.y), zoom: Math.round(this.design.scale * 100), rotate: Math.round(this.design.rot) });
    }
    if (this.three) {
      var self = this;
      clearTimeout(this.threeTimer);
      this.threeTimer = setTimeout(function () {
        self.push3d();
      }, 80);
    }
  };

  // Print sharpness of the chosen image at this size and zoom.
  Customiser.prototype.lowRes = function () {
    var warn = $(this.root, '[data-gh-lowres]');
    if (!warn) return;
    var d = this.design;
    if (!d || !d.img || !d.file) {
      warn.hidden = true;
      return;
    }
    var dims = this.dims();
    var iw = d.img.naturalWidth;
    var ih = d.img.naturalHeight;
    var cover = Math.max(dims.w / iw, dims.h / ih); // inches per image pixel at zoom 100%
    var dpi = Math.round(1 / (cover * d.scale));
    warn.hidden = dpi >= (Number(this.cfg.dpiMin) || 100);
    warn.querySelector('span').textContent = fill(this.L.lowRes, { dpi: dpi });
  };

  Customiser.prototype.bindEditor = function () {
    var self = this;
    var root = this.root;
    var canvas = $(root, '[data-gh-canvas]');
    var zoom = $(root, '[data-gh-zoom]');
    var rotate = $(root, '[data-gh-rotate]');
    if (zoom) {
      zoom.addEventListener('input', function () {
        if (!self.design) return;
        self.design.scale = Number(zoom.value) / 100;
        self.editorChanged();
      });
      rotate.addEventListener('input', function () {
        if (!self.design) return;
        self.design.rot = Number(rotate.value);
        self.editorChanged();
      });
    }
    $$(root, '[data-gh-act]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = self.design;
        if (!d) return;
        var act = btn.dataset.ghAct;
        if (act === 'turn') d.rot = Math.round((d.rot + 90) / 90) * 90;
        if (act === 'centre') d.x = d.y = 0;
        if (act === 'fit') {
          var dims = self.dims();
          var iw = d.img.naturalWidth;
          var ih = d.img.naturalHeight;
          var cover = Math.max(dims.w / iw, dims.h / ih);
          var contain = Math.min(dims.w / iw, dims.h / ih);
          d.scale = Math.max(0.5, contain / cover);
          d.x = d.y = 0;
        }
        if (act === 'reset') {
          d.x = d.y = 0;
          d.scale = 1;
          d.rot = 0;
        }
        self.editorChanged();
      });
    });

    // drag to move, two fingers to zoom and turn
    var pointers = {};
    var start = null;
    function snapshot() {
      var ids = Object.keys(pointers);
      if (!self.design) return null;
      var s = { x: self.design.x, y: self.design.y, scale: self.design.scale, rot: self.design.rot, ids: ids };
      if (ids.length === 1) s.p = pointers[ids[0]];
      if (ids.length >= 2) {
        var a = pointers[ids[0]];
        var b = pointers[ids[1]];
        s.dist = Math.hypot(b.x - a.x, b.y - a.y);
        s.angle = Math.atan2(b.y - a.y, b.x - a.x);
        s.mid = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
      }
      return s;
    }
    canvas.addEventListener('pointerdown', function (e) {
      if (!self.design) return;
      canvas.setPointerCapture(e.pointerId);
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      start = snapshot();
      canvas.classList.add('is-dragging');
    });
    canvas.addEventListener('pointermove', function (e) {
      if (!self.design || !pointers[e.pointerId] || !start) return;
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var k = self.mirror.pxPerInch();
      var ids = Object.keys(pointers);
      if (ids.length === 1 && start.p) {
        self.design.x = start.x + (e.clientX - start.p.x) / k;
        self.design.y = start.y + (e.clientY - start.p.y) / k;
      } else if (ids.length >= 2 && start.dist) {
        var a = pointers[ids[0]];
        var b = pointers[ids[1]];
        var dist = Math.hypot(b.x - a.x, b.y - a.y);
        var angle = Math.atan2(b.y - a.y, b.x - a.x);
        var mid = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
        self.design.scale = Math.min(3, Math.max(0.5, start.scale * (dist / start.dist)));
        self.design.rot = start.rot + ((angle - start.angle) * 180) / Math.PI;
        self.design.x = start.x + (mid.x - start.mid.x) / k;
        self.design.y = start.y + (mid.y - start.mid.y) / k;
      }
      self.editorChanged();
    });
    var end = function (e) {
      delete pointers[e.pointerId];
      start = snapshot();
      if (!Object.keys(pointers).length) canvas.classList.remove('is-dragging');
    };
    canvas.addEventListener('pointerup', end);
    canvas.addEventListener('pointercancel', end);
    // trackpad pinch (sent as ctrl + wheel) zooms; plain wheel keeps scrolling the page
    canvas.addEventListener(
      'wheel',
      function (e) {
        if (!self.design || !e.ctrlKey) return;
        e.preventDefault();
        self.design.scale = Math.min(3, Math.max(0.5, self.design.scale * (1 - e.deltaY * 0.01)));
        self.editorChanged();
      },
      { passive: false }
    );
  };

  /* ----------------------------------------------------------- submit */

  Customiser.prototype.error = function (msg) {
    var el = $(this.root, '[data-gh-error]');
    el.textContent = msg || '';
    el.hidden = !msg;
  };

  Customiser.prototype.submit = function () {
    var self = this;
    var missing = this.missingSteps();
    if (missing.length) {
      var first = missing[0];
      var step = first === 'design' ? this.stepFor('design') : this.root.querySelector('[data-gh-option="' + first + '"]');
      if (first === 'design') this.error(this.L.needDesign);
      if (step) {
        step.scrollIntoView({ behavior: 'smooth', block: 'center' });
        step.classList.add('is-flash');
        setTimeout(function () {
          step.classList.remove('is-flash');
        }, 1200);
      }
      return;
    }
    if (this.custom && !this.customCheck().ok) return;
    this.error('');
    var btn = $(this.root, '[data-gh-add]');
    var label = $(this.root, '[data-gh-add-label]');
    btn.disabled = true;
    btn.classList.add('is-busy');
    label.textContent = this.L.adding;

    var fd = new FormData(this.form);
    fd.delete('gh-design');
    fd.delete('gh-size-mode');
    var done = function (preview) {
      if (self.design && self.design.file) fd.append('properties[' + self.L.propFile + ']', self.design.file, self.design.file.name);
      if (preview) fd.append('properties[' + self.L.propPreview + ']', preview, 'mirror-preview.png');
      fetch((GH.routes ? GH.routes.cartAdd : '/cart/add') + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json().then(function (body) {
            return { ok: r.ok, body: body };
          });
        })
        .then(function (res) {
          btn.disabled = false;
          btn.classList.remove('is-busy');
          label.textContent = self.L.add;
          if (!res.ok) {
            self.error(res.body.description || res.body.message || (GH.strings && GH.strings.cartError));
            return;
          }
          if (GH.afterAdd === 'cart') {
            window.location.href = GH.routes.cart;
            return;
          }
          if (GH.refreshCart) GH.refreshCart();
          if (GH.toast) GH.toast(GH.strings.added, GH.routes.cart, GH.strings.viewCart);
        })
        .catch(function () {
          btn.disabled = false;
          btn.classList.remove('is-busy');
          label.textContent = self.L.add;
          self.error(GH.strings && GH.strings.cartError);
        });
    };
    // a picture of the mirror exactly as it was chosen, for the order
    if (this.design || this.custom) this.mirror.toBlob(900, done);
    else done(null);
  };

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-gh-product]'), function (root) {
      if (!root.ghCustomiser && window.GHMirror && root.querySelector('[data-gh-canvas]')) root.ghCustomiser = new Customiser(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
